/**
 * Plateforme multi événement, © Mika (Mikaël FOURNY).
 * src/components/salon/VersDecouvrir.tsx
 *
 * Rôle :
 *   Redirige l'ancien chemin /salon (celui de NOLAS) vers le chemin neutre
 *   /decouvrir de la page d'exploration de l'événement, en GARDANT recherche,
 *   vue et filtres (`?vue=postes&contrat=…`) et l'ancre : un lien partagé ou
 *   un QR code imprimé reste valable. `replace` : « Retour » ne ramène pas
 *   sur la redirection (sinon boucle).
 *
 *   Composant à part, minuscule et chargé d'emblée : App.tsx le monte sans
 *   tirer la page (chargée à la demande), et le test l'éprouve seul.
 *
 * Mikael - chef de projet - 2026-10-04
 */

import { Navigate, useLocation } from 'react-router-dom';

/** Chemin public de la page d'exploration de l'événement. */
export const CHEMIN_DECOUVRIR = '/decouvrir';

export function VersDecouvrir(): JSX.Element {
  const { search, hash } = useLocation();
  return <Navigate to={{ pathname: CHEMIN_DECOUVRIR, search, hash }} replace />;
}

export default VersDecouvrir;
